export default {
  common: {
    cancel: 'Cancel',
    done: 'Done',
    back: 'Back',
    close: 'Close',
    start: 'Start',
    end: 'End',
    create: 'Create',
    optional: 'Optional',
    loading: 'Loading..',
    undo: 'Undo',
    delete: 'Delete',
    notes: 'Notes',
    save: 'Save',
    more: 'More',
    ok: 'OK',
    errorPrefix: 'Error: {name}. {message}',
  },
  stop: {
    reason: {
      'out-of-stock': 'Out of stock',
      'too-busy': 'Too busy',
      'quality-issue': 'Quality issue',
      'wait-and-retry': 'Slow now, ask later',
      other: 'Other',
    },
  },
  update: {
    title: 'New version available',
    prompt: 'Update to new version?',
    reload: 'Reload',
    toastMessage: 'New version available: v{current} → v{latest}',
    toastMessageFallback: 'A new version is available',
    statusUpToDate: 'Up to date',
    statusChecking: 'Checking…',
    statusAvailable: 'v{latest} available',
    checkNow: 'Check for updates',
    version: 'App version',
  },
  auth: {
    authenticating: 'Authenticating..',
  },
  account: {
    title: 'Account',
    printerSettings: 'Printer Settings',
    availablePrinters: 'Available Printers',
    availableStorefronts: 'Available Storefronts',
    selectPrinter: 'Select Printer',
    selectStorefront: 'Select Storefront',
    selectedPrinter: 'Selected printer',
    groups: {
      settings: 'Settings',
      account: 'Account',
    },
    items: {
      storefront: 'Storefront',
      pushNotifications: 'Push notifications',
      sendTestNotification: 'Send test notification',
      version: 'Version',
      logOut: 'Log out',
      enabled: 'Enabled',
      disabled: 'Disabled',
    },
    debugPrinter: 'Debug Printer',
    unknownStorefront: 'Unknown',
    noDate: 'No date',
    noTime: 'No time',
    printer: {
      title: 'Printer & Fiscal',
      settings: 'Settings',
      devMode: 'Dev mode',
      receiptPreview: 'Receipt preview',
      actions: 'Fiscal actions',
      printDuplicate: 'Print duplicate',
      printXReport: 'Print X report',
      printZReport: 'Print Z report',
      statusLoading: 'Checking printer…',
      statusNotSetUp: 'No printer selected',
      statusError: 'Printer unavailable',
      confirmZ: {
        title: 'Print Z report?',
        message: 'This report can be printed only once. Please confirm to print.',
        confirm: 'Yes, print',
      },
      report: {
        navRow: 'Report for a period',
        title: 'Period report',
        description:
          'Turnover by tax group and VAT for the selected dates, printed on the fiscal printer.',
        from: 'From',
        to: 'To',
        mode: 'Report type',
        detailed: 'Detailed',
        brief: 'Brief',
        withPayments: 'Split by payment type',
        print: 'Print report',
      },
    },
  },
  shift: {
    startShift: 'Start shift',
    goToAccount: 'Go to Account',
    current: 'Current Shift',
    upcoming: 'Upcoming Shift',
    greeting: 'Hey, {name}',
    noShiftAvailable: 'No shift available',
    scheduledStarted:
      'Your shift was scheduled to start on {startTime} until {endTime}, {endDate}.',
    aboutToStart: 'Your shift is about to start on {startDate} {startTime}.',
    nextWillStart:
      'Your next shift will start at {startDate} {startTime}. Activate it in the app starting from {activationTime}.',
  },
  dashboard: {
    title: 'Dashboard',
    loading: 'Loading data..',
    noData: 'No data',
    groups: {
      shifts: 'Shifts',
      today: 'Today',
      inProgress: 'In Progress',
    },
    items: {
      total: 'Total',
      cash: 'Cash',
      card: 'Card',
    },
    shiftPage: {
      fallbackTitle: 'Shift',
      ordersGroup: 'Orders',
      authorizeShift: 'Authorize shift',
      stopShift: 'Stop shift',
      items: 'no items | {count} item | {count} items',
    },
  },
  tabs: {
    title: 'Tabs',
    noOrders: 'No orders found',
    unknownTabName: 'Unknown Tab Name',
  },
  inHouse: {
    orders: 'Orders',
    mapMove: 'Move',
    filters: {
      byStatus: 'By Status',
      byZone: 'By Zone',
      everything: 'Everything',
    },
    loadingOrders: 'Loading orders..',
    noOrders: 'No orders found',
  },
  map: {
    loading: 'Loading map..',
    empty: 'No map created',
    selectTableToMoveTo: 'Select a table to move to',
    moveOrderFromTo:
      'Move order from table {fromName} to {toName}',
    inappropriateObject: 'Moving to/from inappropriate object type',
  },
  search: {
    productsPlaceholder: 'Search products...',
    vendorsPlaceholder: 'Search vendors...',
  },
  products: {
    addProducts: 'Add Products',
    notFound: 'No products found',
    notAvailable: 'No products available',
  },
  vendors: {
    changeVendor: 'Change Vendor',
    notFound: 'No vendors found',
    notAvailable: 'No vendors available',
  },
  procurement: {
    title: 'Procurement',
    newOrder: 'New Order',
    loadingProducts: 'Loading products..',
    noProductsFound: 'No products found',
    loadingOrders: 'Loading orders..',
    noOrdersYet: 'No orders yet',
    orderPrefix: 'Order, ',
    productsCount: 'no products | {count} product | {count} products',
    filters: {
      active: 'Active',
      past: 'Past',
    },
    status: {
      backlog: 'Backlog',
      progress: 'In progress',
      arrived: 'Arrived',
      complete: 'Complete',
    },
    item: {
      fallbackTitle: 'Item',
      setVendor: 'Set vendor',
      tapToAddPhoto: 'Tap to add photo',
      warnings: 'Warnings',
      editAmount: 'Edit amount',
    },
    detail: {
      fallbackTitle: 'Order',
      orderTitle: 'Order, {date}',
      itemsCount: 'no items | {count} item | {count} items',
      noProductsYet: 'No products yet',
      addProductsHint: 'Tap + to add products to this procurement',
      payments: 'Payments',
      noVendor: 'No vendor',
      unknownVendor: 'Unknown vendor',
      unknownProduct: 'Unknown product',
      noDescription: '(no description)',
      badges: {
        primary: 'Primary',
        alternative: 'Alternative',
        newSupply: 'new supply',
        newIngredient: 'new ingredient',
      },
      pendingProduct: {
        willCreateSupply: 'Will create new supply',
        willCreateIngredient: 'Will create new ingredient',
        optOutToExpense: 'One-off — track as expense',
      },
      actions: {
        unreject: 'Unreject',
        notReceived: 'Not Received',
        reject: 'Reject',
        skip: 'Skip',
      },
      scan: {
        uploading: 'Uploading photo…',
        parsing: 'Reading invoice…',
        matching: 'Matching items…',
        refreshing: 'Almost done…',
        documentScanned: 'Document scanned',
        createdVendor: 'Created vendor: {name}',
        scanFailed: 'Scan failed: {message}',
        matchFailed: 'Scan saved, match failed: {message}',
        unknownError: 'unknown',
        noteSheetTitle: 'AI hint (optional)',
        noteSheetHint: 'Add context the AI should use when parsing this document — highest priority over vendor hints.',
        notePlaceholder: 'e.g. Treat every "Other Item" as t-shirt size L.',
        pickPhotos: 'Pick photos',
      },
    },
  },
  transaction: {
    label: 'Transaction #{number}',
    addCash: 'Add Cash',
    addCard: 'Add Card',
    paid: 'Paid',
    pending: 'Pending',
    reversed: 'Reversed',
    reverse: 'Reverse',
    printReceipt: 'Fiscal receipt',
    printPreCheck: 'Pre-check',
    deleteTransaction: 'Delete transaction',
    printerNotConfigured: 'Printer not configured',
    printerError: 'Printer error: {response}',
    printingReceipt: 'Printing receipt…',
  },
  payment: {
    notFound: 'Payment not found',
    label: 'Payment',
    save: 'Save',
    paid: 'paid',
    pending: 'pending',
    date: 'Date',
    amount: 'Amount',
    overrideAmount: 'Override amount',
    overrideHint: 'Custom value, notes required',
    computedHint: 'Computed: {amount} {sign}',
    requiredPlaceholder: 'Required',
    overrideReasonPlaceholder: 'Why this override?',
    notes: 'Notes',
    notesRequired: 'Notes (required)',
    markPaid: 'Mark paid',
    markPending: 'Mark pending',
    methods: {
      cash: 'Cash',
      card: 'Card',
      transfer: 'Transfer',
      other: 'Other',
    },
  },
  order: {
    noYet: 'No order yet',
    createHint: 'Create order by tapping the button.',
    createButton: 'Create Order',
    addMenuItem: 'Add Menu Item',
    sendToWork: 'Send to work',
    checkout: 'Checkout',
    payment: 'Payment',
    total: 'Total',
    paid: 'paid',
    transactions: 'Transactions',
    noTransactionsYet: 'No transactions yet',
    finalise: 'Finalise',
    startBatch: 'Start Batch',
    newBatch: 'New batch',
    controls: 'Controls',
    notLoaded: 'No order or menu-item loaded',
    menus: 'Menus',
    added: 'Added',
    toBatch: 'To Batch',
    toMenu: 'To Menu',
    itemOnStop: 'On stop',
    promotions: 'Promotions',
    actions: {
      addOrderToTable: 'Add order to table',
      assignToMe: 'Assign to me',
      reassignTo: 'Reassign to…',
      reassignPickHeader: 'Assign this table to',
      reassignNoStaffOnShift: 'No staff on shift right now',
      restoreOrder: 'Restore Order',
      cancelOrder: 'Cancel Order',
    },
    batchLabel: 'BATCH #{number}',
    draftBatchLabel: 'DRAFT BATCH',
    commentAlert: {
      header: 'Enter your comment',
      add: 'Add',
      update: 'Update',
      placeholder: 'Enter text here',
    },
    leaveBatchAlert: {
      header: 'Are you sure?',
      message: 'There are non-sent items in the batch.',
      goBack: 'Go back',
    },
    errorPrefix: 'Error: {name}. {message}',
    addItemFailed: {
      noTax: 'Cannot add — no tax group configured for "{name}"',
      inconsistentState: 'Cannot add — inconsistent configurator state',
    },
    moveItems: {
      enter: 'Move items',
      selectTarget: 'Select a table',
      submit: 'Move here',
      submitTo: 'Move {from} → {to}',
      cancel: 'Cancel',
      mustLeaveOne: 'Leave at least 1 item',
      errorNotApplied: 'Move not applied',
      errorReverted: 'Move reverted',
      errorBroken: 'Move broken — items in both orders: {ids}',
    },
    controlsPage: {
      groups: {
        status: 'Status',
        actions: 'Actions',
      },
      markAsInProgress: 'Mark as "In Progress"',
      markAsReady: 'Mark as "Ready"',
      markAsServed: 'Mark as "Served"',
      markAsCancelled: 'Mark as "Cancelled"',
      remove: 'Remove',
      removeLockedInCheckout:
        'The order is being checked out — items are locked. Cancel the checkout first to change the order.',
    },
  },
  tasks: {
    title: 'Tasks',
    callsTitle: 'Calls',
    today: 'Today',
    loadingTasks: 'Loading tasks..',
    noTasksToday: 'No tasks for today',
    subtasksProgress: '{completed} of {total} subtasks',
    allDone: 'All done!',
    detail: {
      fallbackTitle: 'Task',
      progress: 'Progress',
      subtasks: 'Subtasks',
      verification: 'Verification',
      reference: 'Reference',
      activation: 'Activation',
      date: 'Date',
      shift: 'Shift',
      submitted: 'Submitted',
      takePhoto: 'Take a photo',
      addComment: 'Add a comment',
      markAsDone: 'Mark as done',
      undo: 'Undo',
      noRulesMatched: 'No rules matched — showing as directly assigned',
      uploadFailed: 'Upload failed: {message}',
      unknownError: 'Unknown error',
      status: {
        pending: 'Pending',
        'in-progress': 'In progress',
        completed: 'Completed',
        skipped: 'Skipped',
        missed: 'Missed',
      },
      ruleTypes: {
        shiftTemplateId: 'Shift template',
        dayOfTheWeek: 'Day of week',
        dayOfTheMonth: 'Day of month',
        timeOfTheDay: 'Time of day',
        hourOfTheDay: 'Hour',
        minuteOfTheHour: 'Minute',
      },
      weekdays: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
      },
    },
    waiterCalls: {
      noRecent: 'No recent calls',
      hint: "You'll see waiter calls from the last 5 minutes here",
      noTable: 'No table',
      table: 'Table',
      tableNamed: 'Table {name}',
      noStaff: 'No staff',
      staffCount: '{count} staff',
      calledList: 'Called: {names}',
      secondsAgo: '{count}s ago',
      minutesAgo: '{count}m ago',
    },
  },
  promotions: {
    sidebarTitle: 'Applied Promotions',
    contentTitle: 'Add Promotion',
    sidebarPlaceholder: 'Add promotions on the right',
    remove: 'Remove',
    done: 'Done',
    searchInputPlaceholder: 'Start typing',
    searchCancel: 'Cancel',
    searchPlaceholder: 'Start typing and search results will appear here.',
    matchingPromotions: 'Matching Promotions',
    apply: 'Apply',
    applied: 'Applied',
  },
}
